import React, { useState } from 'react';
import Table from "react-bootstrap/Table";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { formatPhoneNumberIntl } from 'react-phone-number-input'
import { sellerListBackDetails, userListBackDetails } from '../../store/actions';
import { setCompanyActiveInActive } from '../../store/actions/company';
import Switch from 'react-switch';
import { toast } from 'react-toastify';
import { companyListBackDetails } from '../../store/actions/rateCard';
import { useDispatch, useSelector } from 'react-redux';
import { checkPermission, formatNumberWithCommas, renderTableRow } from '../../config/utils';
import { accountsManagement, featureSubmodulePermission, permissionAssociatedUser, permissionCompanyAssociatedSeller, permssionEdit, permssionView, SUBF_COMPANY } from '../../constant';
import { Tooltip as WmsTooltip } from "react-tooltip";
import eye_icon from "../../assets/eye_icon.svg";
import edit_icon from "../../assets/edit_icon.svg";
import PropTypes from 'prop-types';

const CompanyList = (props) => {
    const UserValue = useSelector((state) => state.auth.user);
    
    const {
        sortingColumn,
        handleSortingCoulmn,
        sortOrder,
        getAllCompany,
        handleAssociatedSellerPage,
        handleAssociatedUserPage,
        handleCompanyOnboardingReview,
        navigate,
        loader,
        filterData,
        refreshList
    } = props;

    const openWhatsApp = (phoneNumber) => {
        const digits = (phoneNumber || '').replaceAll(/\D/g, '');
        if (!digits) return;
        window.open(`https://wa.me/${digits}`, '_blank');
    };
    const dispatch = useDispatch();
    const { getAllCompanyStatus } = useSelector((state) => state.RateCardReducer);
    const [inactiveTarget, setInactiveTarget] = useState(null);
    const [inactiveSaving, setInactiveSaving] = useState(false);
    const handleCompanyEdit = (rowData) => {
        dispatch(companyListBackDetails(filterData))
        navigate(`/editCompany/comp-${rowData?.Id}`, {
            state: {
                data: rowData,
                editable: false,
            },
        });
    };

    const handleCompanyView = (rowData) => {
        dispatch(companyListBackDetails(filterData));
        const companyId = rowData?.Id;
        navigate(`/editCompany/comp-${rowData?.Id}`, {
            state: {
                data: rowData,
                companyId,
                associatedSeller: false,
                editable: true,
            },
        });
    };

    const handleStatusChange = async (company, isActive) => {
        try {
            const res = await setCompanyActiveInActive(company?.Id, isActive);
            if (res?.data?.Status === 200) {
                toast.success(res?.data?.Entity || 'Status Updated Successfully');
                refreshList?.();
            } else {
                toast.error(res?.data?.Message?.AppStatusDescription || 'Failed to update status');
            }
        } catch (e) {
            toast.error(e?.response?.data?.Message || 'Failed to update status');
        }
    };

    const handleToggleClick = async (company, checked) => {
        if (checked) {
            await handleStatusChange(company, true);
            return;
        }
        setInactiveTarget(company);
    };

    const closeInactiveModal = () => {
        if (inactiveSaving) return;
        setInactiveTarget(null);
    };

    const confirmInactive = async () => {
        setInactiveSaving(true);
        await handleStatusChange(inactiveTarget, false);
        setInactiveSaving(false);
        setInactiveTarget(null);
    };

    const renderColumnHeader = (colName, type) => {
        return (
            <button
                className={(sortingColumn === type) ? "active sortBtn" : "sortColumn sortBtn"}
                onClick={(e) => handleSortingCoulmn(e, type)}
            >
                {colName} {" "}
                <i
                    className={(sortingColumn === type && sortOrder === "ASCENDING") ? "fa fa-arrow-up" : "fa fa-arrow-down"}
                    aria-hidden="true"
                ></i>
            </button>
        )
    }

    return (
        <>
        <Table className={`table  table-height cus-left-right-col-layout ${loader ? "disableTble" : ""}`}>
            <thead border="Green">
                <tr>
                    <th className="head-company">
                        {renderColumnHeader('Company Name', 'name')}
                    </th>
                    <th>
                        {renderColumnHeader('Country', 'country')}
                    </th>
                    <th>
                        {renderColumnHeader('State', 'state')}
                    </th>
                    <th>
                        {renderColumnHeader('Associated Sellers', 'associatedSeller')}
                    </th>
                    <th>
                        {renderColumnHeader('Associated Users', 'associatedUsers')}
                    </th>
                    <th>
                        {renderColumnHeader('Phone Number', 'phonenumber')}
                    </th>
                    <th>
                        {renderColumnHeader('Wallet Balance', 'walletBalance')}
                    </th>
                    <th>Status</th>
                    <th className="sticky">
                        <span className="action-text">Action</span>
                    </th>
                </tr>
            </thead>
            <tbody>
                {getAllCompanyStatus === 'SUCCESS' && getAllCompany?.Entity?.listCompanyMasterOrdersEntity?.map(
                    (list) => (
                        <tr key={list?.Id}>
                            <td>{list?.name}</td>
                            <td>{list?.defaultCountry}</td>
                            <td>{list?.defaultState}</td>
                            <td>
                                {list?.sellerCount > 0 && checkPermission(accountsManagement, SUBF_COMPANY, permissionCompanyAssociatedSeller, featureSubmodulePermission, props.employeePermissions) ? (
                                    <button
                                        className="seller-modal sortBtn tableLink"
                                        onClick={() => {
                                            handleAssociatedSellerPage(list?.Id)
                                            dispatch(sellerListBackDetails({}))
                                        }}
                                    >
                                        {list?.sellerCount}
                                    </button>
                                ) : (
                                    <div>{list?.sellerCount}</div>
                                )}
                            </td>
                            <td>

                                {list?.userCount > 0 && checkPermission(accountsManagement, SUBF_COMPANY, permissionAssociatedUser, featureSubmodulePermission, props.employeePermissions) ? (
                                    <button
                                        className="seller-modal sortBtn tableLink"
                                        onClick={() => {
                                            handleAssociatedUserPage(list?.Id)
                                            dispatch(userListBackDetails({}))
                                        }}
                                    >
                                        {list?.userCount}
                                    </button>
                                ) : (
                                    <div>{list?.userCount}</div>
                                )}
                            </td>
                            <td>
                                <span className="phn-value">
                                    {list?.phoneNumber && (
                                        <button
                                            type="button"
                                            className="sortBtn whatsappIcon mr-1"
                                            onClick={() => openWhatsApp(list?.phoneNumber)}
                                            aria-label="Open WhatsApp"
                                        >
                                            <i className="fa fa-whatsapp" aria-hidden="true"></i>
                                        </button>
                                    )}
                                    {formatPhoneNumberIntl(list?.phoneNumber) || list?.phoneNumber}
                                </span>
                            </td>
                            <td>
                                {`$${formatNumberWithCommas(list?.walletBalance ?? 0)}`}
                            </td>
                            <td style={{ whiteSpace: "nowrap" }}>
                                {UserValue.Value?.isSuperAdmin && checkPermission(accountsManagement, SUBF_COMPANY, permssionEdit, featureSubmodulePermission, props.employeePermissions) ? (
                                    <span className={`companyStatusToggle ${list?.isActive ? 'active' : 'inactive'}`}>
                                        <Switch
                                            onChange={(checked) => handleToggleClick(list, checked)}
                                            checked={!!list?.isActive}
                                            className="switchBtn"
                                            height={24}
                                            width={48}
                                            handleDiameter={20}
                                            offHandleColor="#ffffff"
                                            onHandleColor="#ffffff"
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                        />
                                        <span className="companyStatusLabel">{list?.isActive ? 'Active' : 'Inactive'}</span>
                                    </span>
                                ) : (
                                    <span>{list?.isActive ? 'Active' : 'Inactive'}</span>
                                )}
                            </td>
                            <td className="sticky" style={{ whiteSpace: "nowrap" }}>
                                {checkPermission(accountsManagement, SUBF_COMPANY, permssionView, featureSubmodulePermission, props.employeePermissions) && (
                                    <>
                                        <button className='sortBtn' onClick={() => handleCompanyView(list)}>
                                            <img
                                                className="editIcon mr-15"
                                                style={{ cursor: "pointer" }}
                                                alt=""
                                                src={eye_icon}
                                                id={`${list.Id}-view`}
                                                data-testid={'editIcon'}
                                            />
                                        </button>
                                        <WmsTooltip
                                            anchorId={`${list.Id}-view`}
                                            content={'view'}
                                            place="right"
                                            className="tooltipWidth"
                                        />
                                    </>
                                )}
                                {UserValue.Value?.isSuperAdmin && checkPermission(accountsManagement, SUBF_COMPANY, permssionEdit, featureSubmodulePermission, props.employeePermissions) && (
                                    <>
                                        <button className='sortBtn' onClick={() => handleCompanyEdit(list)}>
                                            <img
                                                className="editIcon mr-15"
                                                style={{ cursor: "pointer" }}
                                                alt=""
                                                src={edit_icon}
                                                id={`${list.Id}-edit`}
                                                data-testid={'editIcon'}
                                            />
                                        </button>
                                        <WmsTooltip
                                            anchorId={`${list.Id}-edit`}
                                            content={'edit'}
                                            place="right"
                                            className="tooltipWidth"
                                        />
                                    </>
                                )}
                                {checkPermission(accountsManagement, SUBF_COMPANY, permssionView, featureSubmodulePermission, props.employeePermissions) && handleCompanyOnboardingReview && (
                                    <>
                                        <button
                                            className='sortBtn'
                                            onClick={() => handleCompanyOnboardingReview(list)}
                                            id={`${list.Id}-review`}
                                            data-testid={'onboardingReviewIcon'}
                                            aria-label="Onboarding Review"
                                        >
                                            <i
                                                className="fa fa-file-text-o"
                                                style={{ color: '#d9534f', fontSize: '18px', cursor: 'pointer' }}
                                                aria-hidden="true"
                                            ></i>
                                        </button>
                                        <WmsTooltip
                                            anchorId={`${list.Id}-review`}
                                            content={'Onboarding Review'}
                                            place="right"
                                            className="tooltipWidth"
                                        />
                                    </>
                                )}
                            </td>
                        </tr>
                    )
                )}
                {getAllCompanyStatus === 'SUCCESS' && getAllCompany?.Entity?.listCompanyMasterOrdersEntity?.length === 0 && (
                    <>{renderTableRow(9, 'No Record Found')}</>
                )}
            </tbody>
        </Table>
        <Modal show={!!inactiveTarget} onHide={closeInactiveModal} centered backdrop="static">
            <Modal.Body>
                <h5 className="mb-3">Mark as Inactive?</h5>
                <p>
                    Mark <strong>{inactiveTarget?.name}</strong> as Inactive? All its sellers will also become Inactive.
                </p>
                <div className="d-flex justify-content-end mt-3">
                    <Button variant="light" className="border mr-2" onClick={closeInactiveModal} disabled={inactiveSaving}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={confirmInactive} disabled={inactiveSaving}>
                        Confirm
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
        </>
    );
}

CompanyList.propTypes = {
    sortingColumn: PropTypes.string,
    handleSortingCoulmn: PropTypes.func.isRequired,
    sortOrder: PropTypes.string,
    getAllCompany: PropTypes.object,
    handleAssociatedSellerPage: PropTypes.func.isRequired,
    handleAssociatedUserPage: PropTypes.func.isRequired,
    handleCompanyOnboardingReview: PropTypes.func,
    navigate: PropTypes.func.isRequired,
    loader: PropTypes.bool,
    filterData: PropTypes.object,
    refreshList: PropTypes.func,
    employeePermissions: PropTypes.array
};

export default CompanyList;